import * as React from 'react';
// import {
// 	BrowserView,
// 	MobileView,
// 	isBrowser,
// 	isMobile
// } from "react-device-detect";
import { NavigationContext } from '../../design/nav/NavigationContext';
import { MenuApp } from '../../../app/menu';

export const Nav = (props: any) => {
	const NavContext = React.useContext(NavigationContext);
	let menuClasses = 'menu-block isClosed';

	if (NavContext.navStatus) {
		menuClasses = 'menu-block';
	}

	return (
		<div className="nav-container">
			<aside className={menuClasses}>
				<ul>
					<MenuApp />
				</ul>
			</aside>
		</div>
	);
};
